export const COLOR_MAP: Record<string, string> = {
  blue: '#1890ff',
  green: '#52c41a',
  purple: '#722ed1',
  orange: '#fa8c16',
  teal: '#13c2c2',
  red: '#ff4d4f',
  cyan: '#13c2c2',
  indigo: '#2f54eb',
  yellow: '#fadb14',
};

export type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night';

// Buckets the viewer's local hour into a time of day, used to pick the greeting icon.
export const getGreetingTime = (d: Date = new Date()): TimeOfDay => {
  const currentHour = d.getHours();

  if (currentHour >= 5 && currentHour < 12) return 'morning';
  if (currentHour >= 12 && currentHour < 17) return 'afternoon';
  if (currentHour >= 17 && currentHour < 21) return 'evening';
  return 'night';
};

// Shared period filter used by every chart card's dropdown, for consistency.
export const PERIOD_FILTER_OPTIONS = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: '90days', label: 'Last 90 Days' },
  { value: '1year', label: '1 Year' },
];

// The channel/platform filter's option list lives in PlatformFilterDropdown.tsx
// (needs JSX for icons, so it can't live in this plain .ts file) — see
// PLATFORM_OPTIONS there. The same dropdown component is reused both
// standalone (above the stat cards) and inline in each chart card's header.

// --- The charts/widgets below aren't wired to real endpoints yet — dummy data as a placeholder until those APIs exist. ---

export const MOCK_ORDERS_TODAY = 24;
export const MOCK_TODAY_SALES = 486;

export const MOCK_ORDER_STATUS_BREAKDOWN = [
  { label: 'Pending', value: 6, color: COLOR_MAP.orange },
  { label: 'Ready', value: 4, color: COLOR_MAP.blue },
  { label: 'Completed', value: 14, color: COLOR_MAP.green },
];

export const MOCK_REVENUE_LABELS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export const MOCK_REVENUE_SERIES = [
  {
    label: 'Revenue',
    color: COLOR_MAP.blue,
    data: [2400, 2100, 2800, 3200, 2950, 3600, 4100, 3850, 4400, 4150, 4700, 5200],
  },
  {
    label: 'Refunds',
    color: COLOR_MAP.red,
    data: [200, 260, 180, 300, 340, 220, 260, 310, 240, 280, 260, 300],
  },
];

export const MOCK_ORDERS_BY_HOUR = [
  { label: '9AM', value: 3 },
  { label: '11AM', value: 6 },
  { label: '1PM', value: 12 },
  { label: '3PM', value: 8 },
  { label: '5PM', value: 10 },
  { label: '7PM', value: 15 },
  { label: '9PM', value: 9 },
];

export const MOCK_ORDER_CHANNEL_SPLIT = [
  { label: 'Kiosk', value: 55, color: COLOR_MAP.blue },
  { label: 'Web', value: 30, color: COLOR_MAP.teal },
  { label: 'Mobile App', value: 15, color: COLOR_MAP.purple },
];
